import { useEffect, useState } from 'react'
import { Box, Grid, styled, Theme, Typography } from '@mui/material'

import { runClientEff } from '@ecm/effect'
import GenericCtaForm from '@ecm/ui/component/form/GenericCtaForm'
import CloudflareImage from '@ecm/ui/element/CloudflareImage'
import Color from '@ecm/ui/element/Color'

import Postcard from '/public/images/illustration/new-postcard.svg'

type NewsletterSignupCtaProps = {
  className?: string
  small?: boolean
  trackGaEvents?: boolean
}

export const NewsletterSignupCta = styled(
  ({ className, small, trackGaEvents }: NewsletterSignupCtaProps) => {
    const [formId, setFormId] = useState('')

    useEffect(() => {
      runClientEff(async eff => {
        setFormId(eff.ask().hubSpot.formIds.newsletterSignup)
      })
    }, [])

    return (
      <Grid container className={className} justifyContent="center" mb={small ? '2em' : 0}>
        <Grid
          container
          sx={{
            alignItems: 'center',
            bgcolor: Color.smoke.lighter,
            borderRadius: '8px',
            color: Color.saint.normal,
            gap: '1em',
            justifyContent: { md: 'space-around', xs: 'center' },
            maxWidth: 'md',
            padding: '2em',
          }}
        >
          <Box width={small ? '90px' : undefined} maxWidth="185px">
            <CloudflareImage src={Postcard} />
          </Box>
          <Grid
            container
            flexDirection="column"
            justifyContent="center"
            width="auto"
            maxWidth="35em"
          >
            <Typography
              variant="h5"
              component="h2"
              color={Color.saint.darker}
              textAlign={{ md: small ? 'center' : 'left', xs: 'center' }}
            >
              Find out more with The Postcard
            </Typography>
            {small ? (
              <Typography variant="p3" color={Color.saint.darker} margin="0" textAlign="center">
                Subscribe to get <b>updates, special offers, and more!</b>
              </Typography>
            ) : (
              <Typography
                variant="p3"
                color={Color.saint.darker}
                my="0.5em"
                textAlign={{ md: 'left', xs: 'center' }}
              >
                The Postcard, our monthly email, keeps you updated on{' '}
                <b>new products, event invites, virtual mailbox tips, and special promotions.</b>
              </Typography>
            )}
            <GenericCtaForm
              leadProps={{ newsletterSubscriber: 'true' }}
              formId={formId}
              small={small}
              source="Newsletter Signup"
              submitBtnText="Send it to me!"
              trackGaEvents={trackGaEvents}
            />
          </Grid>
        </Grid>
      </Grid>
    )
  }
)(({ theme, small }: NewsletterSignupCtaProps & { theme: Theme }) => ({
  button: {
    height: small ? '44px' : null,
    width: small ? '100%' : '180px',
    [theme.breakpoints.down('md')]: { width: '100%' },
  },
  input: {
    height: small ? '44px !important' : null,
  },
  'input~div': {
    height: small ? '16px' : null,
  },
}))

export default NewsletterSignupCta
